import AppList from 'common/components/list.component';
import CatalogUtils from 'config/utils/catalog.util';
import React, { useCallback } from 'react';
import { Item } from 'store/models/cart.model';
import { User } from 'store/models/user.model';
import CardControls from '../product-card/card-controls.component';
import ProductListItem from '../product-list-item.component';
import ProductNoStock from '../product-no-stock.component';

type ProductListProps = {
  items: Item[];
  isAuthenticated: boolean;
  withControls?: boolean;
  userProfile: User;
};

const ProductList: React.FC<ProductListProps> = ({ items, isAuthenticated, withControls, userProfile }) => {
  const handleDeleteProductFromCart = (listItem: Item) => {
    CatalogUtils.removeToCart(listItem.product, listItem.variant);
  };

  const renderCardControls = (listItem: Item) => (
    <CardControls
      cartItems={items}
      favorites={userProfile.favorites}
      isAuthenticated={isAuthenticated}
      product={listItem.product}
      withFavoriteButton={false}
      withQuantityContainerSmall={true}
      selectedVariant={listItem.variant}
      userProfile={userProfile}
    />
  );

  const renderListItem = useCallback(
    (listItem: Item, index: number): React.ReactNode => (
      <ProductListItem
        key={listItem.variant.sku ?? `${listItem.product._id}-${index}`}
        item={listItem}
        extraContent={
          !CatalogUtils.productVariantHasStock(listItem.variant) ?
            <ProductNoStock onDeleteProductFromCart={() => handleDeleteProductFromCart(listItem)} withButton={true} />
          : withControls ?
            renderCardControls(listItem)
          : null
        }
      />
    ),
    [items, userProfile.favorites, isAuthenticated, withControls],
  );

  return <AppList dataSource={items} renderItem={(appListItem, appListIndex) => renderListItem(appListItem, appListIndex)} />;
};

export default ProductList;
